export default __webpack_public_path__ + "static/media/mathieu.e17fbf7a.jpg";